import { mediaMax } from "components/designV2/breakpoints";
import { Spacing } from "components/designV2/constants";
import styled from "styled-components";

export const ExportsPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.lg}px;
  margin-bottom: ${Spacing.xl * 3}px;
`;

export const ExportsHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const ExportGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${Spacing.md}px;

  ${mediaMax.desktop} {
    grid-template-columns: 1fr;
  }
`;

export const ExportRowContent = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacing.md}px;
  min-width: 0;
`;
